import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PendingChangesService {
  private unsavedChanges = false;

  setUnsavedChanges(status: boolean): void {
    this.unsavedChanges = status;
  }

  hasUnsavedChanges(): boolean {
    return this.unsavedChanges;
  }
}
